// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"k9-z","displaySixCardTiles":"l9-z"};